import React from 'react';
import Hdr from '../shared/Hdr';
import { Link } from 'react-router-dom';

import { useState, useEffect } from 'react';
import swal from 'sweetalert';

import { apiPath1 } from "../services/apiConfig";
import TopBanner from '../components/TopBanner';

//import { motion, AnimatePresence } from "framer-motion";

function SiteIssu() {

//const user = localStorage.getItem('user-info');
const token = localStorage.getItem('token');
//const usrRole = localStorage.getItem('user-role');
//const user_id = localStorage.getItem('user-id');
//const usrName = localStorage.getItem('userName');
const sid = localStorage.getItem('store-id');

const [selectedDate, setSelecteDate] = useState()
const [trNo, setTrNo] = useState()
const [storeitems, setStoreItems] = useState([])


const [issueLineitemStatus,setIssueLineitemStatus] = useState()
const [issueLineitem, setIssueLineitem] = useState()
const [formattedDate,setFormattedDate] = useState()
const [storedata, setStores] = useState([])
const [selectedStoreValue, setSelectedStoreValue] = useState('0')
const [type, setType] = useState('Tool')
const [inventoryDataStatus,setInventoryDataStatus] = useState()
const [inventoryData,setInventoryData] = useState([])
const [lineitem, setLineItem] = useState([])
const [qty, setQty] = useState()
const [toolDetails, setToolDetails] = useState([])

const [toolCode, setToolCode] = useState()
const [toolName, setToolName] = useState()
const [uom, setUOM] = useState()
const [toolId,setToolId] = useState()

const [stock, setStock] = useState(0)


function addSiteIssue(){}
function deleteItem(){}

function toolCodeHandler(e){
 
  getToolDetails(e.target.value)

}

async function getToolDetails(id){

 //  alert ('tool code Handler '+ id)

  let result = await fetch(apiPath1 + "InUseAndSpareStock",
    {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "tool_id": id,
        "store_id": selectedStoreValue
      })
    });

  result = await result.json();

  if (result.status === true) {
     setToolDetails(result.data) 
     setToolCode(result.data.tool_code)
     setToolName(result.data.tool_name)
     setUOM(result.data.uom)
     setStock(result.data.spare)
    
    }
  else { setToolDetails([]) }
}

function addItem(){
  /*
  if (qty === undefined || qty <= 0 || selectedToolCode === undefined) {
    swal({
      title: "Fail!",
      text: "Quantity be must be more than Zero",
      icon: "error",
      button: "OK!",
    });
    return
  }
*/


  setIssueLineitem(
    [
      ...issueLineitem,
      {
        id: issueLineitem.length+1,
        tool_code: toolCode,
        tool_id: toolId,
        tool_name: toolName,
        quantity: qty,
        uom: uom
      }
    ]
  );

  setIssueLineitemStatus(true)


}


const currentDate = new Date(); 

  useEffect(() => {
    //alert(sid)
    getCurrentDate()
    getStores()
  }, [])


function getCurrentDate(){ 
    setFormattedDate(`${String(currentDate.getDate()).padStart(2, '0')}/${String(currentDate.getMonth() + 1).padStart(2, '0')}/${currentDate.getFullYear()}`);
}

function typeHandler(e){

 // alert(e.target.value)
  e.preventDefault()
  setType(e.target.value)
  getInventory2(e.target.value, selectedStoreValue)
}

async function getStores() {

    let result = await fetch(apiPath1 + "Stores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setStores(result.data) }
    else { setStores([]) }
}

function storeHandler(e) {

  e.preventDefault()
  setSelectedStoreValue(e.target.value)
  getInventory2(type, e.target.value)
}

  async function getInventory2(type, store) {

 //       alert('Inventory2 - type : '+type+', Store: '+store)      

    let result = await fetch(apiPath1 + "InventoryByToolTypeAndStore",
      {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "toolType": type,
          "storeId": store
        })
      });
    result = await result.json();

    setInventoryDataStatus(result.status)

    if (result.status === true) {
       setInventoryData(result.data) 
    }
    else { 
      setInventoryData([]) 
    }
  }

  function qtyHandler(e){
    setQty(e.target.value)

  }


  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Tools & Consumables Issue'} />

      <div className="row p16" style={{ 'height': '95%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>

          <div id="newTr" className="cont__AddItems">
            <form className="" action="" method="">
       
              <div className="row box gradient corner-round-tlr">
                <div className="c12-l-2">
                  <h3 className='txt-subtlewhite'>Site Issue</h3><br />
                </div>
                <div className="c12-l-9"></div>

              </div>
   
              <div className="row mt8 px16">
                <div className="c12-l-12">
                  <div className="row">
                    <div className='c12-l-4 pr12'>

                      <p>Issue Number</p>
                      <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        placeholder="New Site Issue" value={trNo} disabled={true} />

                      <p>Issue Date</p>
                      <input type="text" value={formattedDate} className="box small" style={{ "width": '98%', 'marginTop': '1px' }} />



                    </div>

                    <div className='c12-l-8 pr4'>
                      <div className='row'>
                        <p>Store Name</p>
                        <select className="small" value={selectedStoreValue} onChange={storeHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                          <option value="0" >Select Store</option>
                          {
                            storedata.map((item, index) =>
                              <option key={item.id} value={item.id}>{item.store_name}</option>
                            )
                          }
                        </select>
                      
                        <p>Receiver's Name</p>
                        <input type="text" className="box small" style={{ "width": '98%', 'marginTop': '1px' }} 
                        placeholder='Receiver Name'/>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>

                  <div className="row px16">
                    <div className="c12-g-l-3" >
                        <p className='txt-darkblue mb2' style={{ 'marginLeft': '4px' }}>Select Tool Type</p>
                        <select className="small" onChange={typeHandler}>
                            <option value="">All Tools</option>
                            <option value="Tool">Tool</option>
                            <option value="Consumable">Consumable</option>
                        </select>
                    </div>

                    <div className='c12-l-3'>
                      <p className='txt-darkblue mb2' style={{ 'marginTop': '5px' }}>Select Tools</p>
                      <select className="small" onChange={toolCodeHandler} style={{ "width": '98%', 'marginTop': '1px' }}>
                        <option value="0" >Select Tools</option>
                        {
                          (inventoryDataStatus === true ?
                            (
                                inventoryData.map((item, index) =>
                                  <option key={item.id} value={item.tool_id}>{item.tool_name}</option>
                                )
                              ):null)}
                      </select>
                    </div>

                    <div className='c12-l-2'>
                        <p className='txt-darkblue mb2' style={{ 'marginTop': '5px' }}>Stock</p>
                        <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                         value={stock} />
                    </div>

                    <div className='c12-l-2'>
                        <p className='txt-darkblue mb2' style={{ 'marginTop': '5px' }}>Issued Qty</p>
                        <input type="number" className="box small" style={{ "width": '98%', 'marginTop': '1px' }}
                        onChange={qtyHandler}  />
                    </div>

                    <div className='c12-l-2'>
                      <button onClick={addItem} name='qty' type="button" style={{ 'marginTop': '22px', 'width': '90%' }}
                        className="btn gradient round">Add Item</button>
                    </div>
                  
                  
                </div>


                <div className='row mt8 px16'>
                  <div className="row style={{'height':'95%'}}">
                    <div className="c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
                      <table style={{ 'height': '200px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                        <thead className='thead-grey'>
                          <tr>
                            <th className="th-border" width="8%">Id</th>
                            <th className="th-border left" width="15%">Tool Code</th>
                            <th className="th-border left" width="40%">Tool Name</th>
                            <th className="th-border left" width="15%">Quantity</th>
                            <th className="th-border left" width="15%">Unit</th>
                            <th className="th-border" width="8%">Delete</th>
                          </tr>
                        </thead>
                        
                        <tbody>
                          {
                            (issueLineitemStatus === true ?
                              (
                                issueLineitem.map((item, index) =>
                                  <tr className="tr-border" key={index}>
                                    <td className="center">{item.id}</td>
                                    <td hidden className="">{item.tool_id}</td>
                                    <td className="">{item.tool_code}</td>
                                    <td className="">{item.tool_name}</td>
                                    <td className="">{item.quantity}</td>
                                    <td className="">{item.uom}</td>
                                   <td onClick={() => { deleteItem(item.id) }} className="center"><img src={require('../asset/icons/adm_del.png')} alt="" /></td>
                                  </tr>
                                ))
                              : <tr><td>No data</td></tr>)
                          }
                        </tbody>
                        
                      </table>
                    </div>
                  </div>

                  <button onClick={addSiteIssue} type="button" name="button"
                    className="btn gradient large round">Add Site Issue</button>
                </div>
              
              
            </form>
          </div>


       
      </div>
    </div>

    </div>
  );
}

export default SiteIssu;
